import { render, staticRenderFns } from "./TagEventLogItem.vue?vue&type=template&id=6423c181&scoped=true&"
import script from "./TagEventLogItem.vue?vue&type=script&lang=js&"
export * from "./TagEventLogItem.vue?vue&type=script&lang=js&"
import style0 from "./TagEventLogItem.vue?vue&type=style&index=0&id=6423c181&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6423c181",
  null
  
)

export default component.exports